<template>
  <div>trading</div>
</template>